import React from 'react';
import { Translation } from 'react-i18next';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const DOCUMENT_ACCESS_OPTIONS = [
  {
    key: 'true',
    value: 1,
    text: <Translation ns="shared">{t => t('impersonation.yes')}</Translation>,
  },
  {
    key: 'false',
    value: 0,
    text: <Translation ns="shared">{t => t('impersonation.no')}</Translation>,
  },
];

const DocumentAccessFilter = () => (
  <IconFilter
    hasApplyButton
    clearable
    name="documentAccessEnabled"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={DOCUMENT_ACCESS_OPTIONS}
  />
);

export default DocumentAccessFilter;
